<form class="grid-container grid-3" [formGroup]="formGroup">
    <ui-form-field class="grid-row-1" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.VALUE' | translate">
        <ui-select
            formControlName="measureCode"
            labelField="name"
            valueField="measureCode"
            [options]="availableMeasures"
            [required]="true"
            [disabled]="!availableMeasures?.length || disabled"
        />
    </ui-form-field>
    <ui-form-field class="grid-row-1" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.CAPTION' | translate">
        <input advizeoInput formControlName="caption" [disabled]="disabled" />
    </ui-form-field>
</form>
